import { createSelector } from 'reselect';
import { USER_ATTRIBUTE_DEFAULT_DUE_DATE_PRESET, USER_ATTRIBUTE_DEFAULT_DUE_TIME, USER_ATTRIBUTE_DEFAULT_REMINDER_PRESET, USER_ATTRIBUTE_HIDE_FOLLOW_UP_TASKS, USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS } from '../constants/UserAttributesKeys';
import get from 'transmute/get';
export const allStagedSettingsSelector = state => state.stagedSettings;
export const allPersistentSettingsSelector = state => state.persistentSettings;
export const allSettingsSelector = createSelector(allPersistentSettingsSelector, allStagedSettingsSelector, (persistentSettings, stagedSettings) => Object.assign({}, persistentSettings, stagedSettings));
export const allModifiedSettingsSelector = createSelector(allPersistentSettingsSelector, allSettingsSelector, (persistentSettings, allSettings) => {
  const result = {};
  Object.keys(allSettings).forEach(k => {
    const key = k;
    if (allSettings[key] !== persistentSettings[key]) {
      result[key] = allSettings[key];
    }
  });
  return result;
});
export const modifiedSettingsCountSelector = createSelector(allModifiedSettingsSelector, allModifiedSettings => Object.keys(allModifiedSettings).length);
export const hideFollowUpPopoverSettingSelector = createSelector(allSettingsSelector, get(USER_ATTRIBUTE_HIDE_FOLLOW_UP_TASKS));
export const hideLeadFollowUpPopoverSettingSelector = createSelector(allSettingsSelector, get(USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS));
export const defaultDueDatePresetSelector = createSelector(allSettingsSelector, get(USER_ATTRIBUTE_DEFAULT_DUE_DATE_PRESET));
export const defaultDueTimeSelector = createSelector(allSettingsSelector, get(USER_ATTRIBUTE_DEFAULT_DUE_TIME));
export const defaultReminderPresetSelector = createSelector(allSettingsSelector, get(USER_ATTRIBUTE_DEFAULT_REMINDER_PRESET));